import router from './index'
import store from '../store/index'

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('X-Token')
  // 如果当前页面需要登录并且未登录
  if (to.meta.loginRequired && !token) {
    // 存储当前路由为登录返回做准备
    sessionStorage.setItem('lastPath', router.currentRoute.name)
    next({ name: 'login' })
  } else {
    next()
  }
})

router.afterEach(to => {
  // window.scrollTo(0, 0)
  // 面包屑存储
  if (to.name) {
    let breadList = localStorage.getItem('breadList') ? JSON.parse(localStorage.getItem('breadList')) : []
    if (!to.meta.breadList) {
      return
    }
    let arr = to.meta.breadList.map(item => {
      const obj = breadList.find(cls => item === cls.routerName)
      if (item === to.name) {
        return {
          path: to.fullPath,
          title: to.meta.title,
          routerName: to.name
        }
      } else {
        return obj
      }
    })
    arr = arr.filter(item => item)
    store.commit('SET_BREADLIST', arr)
    localStorage.setItem('breadList', JSON.stringify(arr))
  }
})
